import React, { useState } from "react";
import { IconButton, Popover } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import LogPopover from "./LogPopover";

export default function HoverableMessageIcon({ logs }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onMouseEnter={handlePopoverOpen} size="small">
        <MessageIcon color="warning" />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableAutoFocus
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onMouseLeave={handlePopoverClose}
      >
        <LogPopover
          logs={logs.filter((log) => log.UserAction === "Skapat logg manuellt")}
        />
      </Popover>
    </>
  );
}
